module.exports = __webpack_public_path__ + "img/check and wrong animation.6033c595.gif";